import React, {useState} from 'react';
import {Form, Formik, Field} from 'formik';
import {Alert, Button, FormGroup, Input, Label} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronLeft} from '@fortawesome/pro-regular-svg-icons';

import {useUserDispatch, useUserState} from 'contexts/user';
import {submitForm} from 'utils/forms';

import CustomRadioField from '../../../components/CustomRadioField';
import {navigate} from '@reach/router';
import {questions} from 'data/questions.json';

const {QUIZ_RESULTS_FORM_ID} = process.env;

export default function QuizQuestionsForm({onComplete = () => {}}) {
  const userDispatch = useUserDispatch();
  const {quizRegistrationId, uuid} = useUserState();

  function QuizQuestion({question, name, options, value, ...props}) {
    return (
      <FormGroup className="text-left mb-4" tag="fieldset" value={value}>
        <h4 className="quiz-question mt-3 mb-4">
          <strong>{question}</strong>
        </h4>
        {options.map((option, i) => (
          <FormGroup className="form-check-radio" check>
            <Label check>
              <Field name={name} value={i.toString()} component={CustomRadioField} /> {option}
            </Label>
          </FormGroup>
        ))}
      </FormGroup>
    );
  }

  const [step, setStep] = useState(0);

  return (
    <>
      <div className="optin-wrap">
        <Formik
          initialValues={{q: []}}
          onSubmit={(values, actions) => {
            const answerSet = values.q.map((value, i) => value === questions[i].answer);
            const score = Math.round(
              (answerSet.reduce(
                (previousValue, currentValue, i) => (currentValue ? previousValue + 1 : previousValue),
                0
              ) /
                questions.length) *
                100
            );

            return submitForm({registrationId: quizRegistrationId, uuid, completed: true}, QUIZ_RESULTS_FORM_ID)
              .then(() => onComplete())
              .then(() =>
                navigate('/masterclass/?o=quiz', {state: {fromQuiz: true, answerSet, score, answers: values.q}})
              )
              .catch((e) => {
                actions.setStatus({error: e});
                actions.setSubmitting(false);
              });
          }}
          render={({values, handleSubmit, isSubmitting, isValid, handleReset, status, ...props}) => (
            <Form onSubmit={handleSubmit}>
              {status && status.error && <Alert color="danger">{status.error}</Alert>}

              <QuizQuestion name={`q[${step}]`} value={values.q[step]} {...questions[step]} />

              <div className="btn-wrap d-flex align-items-center">
                {step > 0 ? (
                  <div className="btn-back-wrap mr-3">
                    <Button
                      className="text-uppercase text-h4"
                      color="back"
                      type="button"
                      onClick={() => {
                        setStep(step - 1);
                      }}
                    >
                      <FontAwesomeIcon icon={faChevronLeft} />
                    </Button>
                  </div>
                ) : null}

                <Button
                  className="text-uppercase text-h4 text-condensed text-800"
                  color="cta"
                  type="button"
                  disabled={!values.q[step]}
                  onClick={() => {
                    step < questions.length - 1 ? setStep(step + 1) : handleSubmit();
                  }}
                  block
                >
                  {step < questions.length - 1 ? 'Next Question' : 'Get Your Score'}
                </Button>
              </div>
            </Form>
          )}
        />
      </div>
    </>
  );
}
